import { useContext } from 'react'
import { ApplicationContext } from '../../context/appContext'

const useApplicationContext = () => {
  const context = useContext(ApplicationContext)

  if (context === undefined) {
    throw new Error('Application Context must be used inside Application Tree')
  }

  return context
}

export default useApplicationContext
